'use client'

import { ComponentProps, useMemo } from 'react'

import { cn, isNilOrEmptyString } from '@/shared/lib'
import { Popover } from '@/shared/ui'

type Props = ComponentProps<typeof Popover.Content> & {
  defaultOpen?: boolean
  message: string | null
}

export const ContractPopover = ({
  defaultOpen: defaultOpenProp,
  message,
  children,
  className,
  ...props
}: Props) => {
  const defaultOpen = useMemo(() => {
    if (defaultOpenProp !== undefined) {
      return defaultOpenProp
    }

    return !isNilOrEmptyString(message)
  }, [defaultOpenProp, message])

  return (
    <Popover.Root defaultOpen={defaultOpen}>
      <Popover.Anchor asChild>{children}</Popover.Anchor>
      <Popover.Content
        color="purple"
        side="left"
        sideOffset={6}
        className={cn('text-left whitespace-break-spaces', className)}
        onInteractOutside={e => {
          e.preventDefault()
        }}
        onEscapeKeyDown={e => {
          e.preventDefault()
        }}
        {...props}
      >
        {message}
      </Popover.Content>
    </Popover.Root>
  )
}
